<template>
    <div class="medal-block">
        <div class="medals">
            <div class="medal bronze" :class="{won: medalType.toLowerCase() === 'bronze' }"></div>
            <div class="medal silver" :class="{won: medalType.toLowerCase() === 'silver' }"></div>
            <div class="medal gold" :class="{won: medalType.toLowerCase() === 'gold' }"></div>
            <div class="medal platinum" :class="{won: medalType.toLowerCase() === 'platinum' }"></div>
        </div>
        <div class="label">You Got<strong>{{medalType}}</strong></div>
    </div>
</template>

<script>
    import { gsap } from '/src/assets/js/gsap'
    export default {
        name : "Medal",
        props: {
            medalType: String,
        }
    }
</script>